var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"text-left list-reset"},_vm._l((_vm.options),function(opt){return _c('li',{key:opt.value,staticClass:"item",class:{ 'is-selected': _vm.value === opt.value },on:{"click":function($event){return _vm.handleSelectGuests(opt.value)}}},[_vm._v("\n      "+_vm._s(opt.label)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }